import { Point } from '../../graphicLibs/index';
import { PointInfo } from '../../WalltoFittingInfo';

/**
 * 小さい部屋の削除
 * */
export class SmallRoomCorrection {

    private threshold = 0;

    constructor(public pointList: PointInfo[]) {

    }

    // length: m単位
    // 小さい部屋の削除 一つでもlength以上の壁があったら削除しない
    public execute(roomIndexes: number[]): PointInfo[] {
        let isDelete = true;
        roomIndexes.forEach((roomIndex: number, index: number, array: number[]) => {
            const next = Point.nextPoint(roomIndex);
            const dir = this.pointList[next].point.clone().sub(this.pointList[roomIndex].point);
            const l = dir.clone().length();

            if (l > this.threshold) isDelete = false;
        });
        
        if (isDelete) {
            roomIndexes.forEach((i: number) => {
                this.pointList[i].isDelete = true;
                this.pointList[Point.nextPoint(i)].isDelete = true;
            });
        }

        return this.pointList;
    }


    public length(e: number) {
        this.threshold = e / 1000; /** 単位 mm → m */
    }

}